import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppConfiguration } from './models';
import { VersionService } from './services';
// import { CompanyConfigFacade } from '@symphony-solo/domain/company-config/src/lib/+state/company-config.facade';

@NgModule({
  imports: [CommonModule],
})
export class SharedAppConfigurationModule {
  public static forRoot(config: AppConfiguration): ModuleWithProviders {
    return {
      ngModule: SharedAppConfigurationModule,
      providers: [
        // {
        //   provide: APP_INITIALIZER,
        //   useFactory: (companyConfigFacade: CompanyConfigFacade) => () => {
        //     console.log('APP_INITIALIZER');
        //     companyConfigFacade.getCompanyConfig();
        //   },
        //   deps: [CompanyConfigFacade],
        //   multi: true,
        // },
        {
          provide: AppConfiguration,
          useValue: config,
        },
        VersionService,
      ],
    };
  }
}
